import React from "react";
import { Link } from "react-router-dom";
import { FaHandshake } from "react-icons/fa"; // optional: use react-icons

const HeroBanner = () => {
  return (
    <div
      className="banner-area tpbanner-space-two"
      style={{
        background: "linear-gradient(145deg, #f9fafc 0%, #eef2f6 100%)", // soft light gradient
        color: "#1e293b",
        padding: "70px 0",
      }}
    >
      <div className="container" style={{ paddingTop: "40px" }}>
        <div className="row align-items-center">
          {/* Left content */}
          <div className="col-lg-7 col-md-7 order-2 order-md-1">
            <div className="tpbanner-content-two">
              {/* Optional small badge */}
              <span
                style={{
                  display: "inline-block",
                  backgroundColor: "#f39c1220",
                  color: "#f39c12",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  padding: "4px 12px",
                  borderRadius: "30px",
                  marginBottom: "16px",
                }}
              >
                🇮🇳 India's Fastest Growing Fintech
              </span>

              <h1
                className="tpbanner-title-two mb-4"
                style={{
                  fontSize: "clamp(2.2rem, 4.5vw, 3.2rem)", // slightly reduced
                  fontWeight: "700",
                  lineHeight: "1.2",
                  color: "#1e293b",
                }}
              >
                Digital Financial Services <br />
                <span style={{ color: "#f39c12" }}>
                  for Every Retailer
                </span>{" "}
                Made Simple.
              </h1>

              <p
                className="mb-4"
                style={{
                  fontSize: "1.15rem",
                  color: "#475569",
                  maxWidth: "90%",
                }}
              >
                Happy Pay Fintech makes it simple for retailers and agents to
                offer AEPS, DMT, CMS, PAN card, and bill payment services – all
                from one platform.
              </p>

              <div className="tpbanner-two-btn mb-4">
                <Link
                  className="btn btn-primary btn-lg"
                  to="/contact-us"
                  style={{
                    backgroundColor: "#f39c12",
                    borderColor: "#f39c12",
                    color: "#1e293b",
                    fontWeight: "600",
                    padding: "12px 30px",
                    borderRadius: "50px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    boxShadow: "0 8px 20px rgba(243, 156, 18, 0.3)",
                  }}
                >
                  <FaHandshake /> Become a Retailer
                </Link>
              </div>

              <div className="tpbanner-two-rating d-flex align-items-center gap-2 flex-wrap">
                <span style={{ color: "#64748b" }}>Trusted by</span>
                <strong style={{ color: "#1e293b", fontSize: "1.3rem" }}>
                  20,000+ retailers and distributors
                </strong>
                <span style={{ color: "#64748b" }}>across India</span>
                {/* Optional star rating or icon */}
                <span style={{ color: "#f39c12", marginLeft: "4px" }}>
                  ★★★★★
                </span>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="col-lg-5 col-md-5 order-1 order-md-2">
            <div
              className="tpbanner-two-shape p-relative text-center"
              data-parallax='{"x": 15, "smoothness": 10}'
            >
              <img
                src="/images/fintech-hero.jpg" // replace with your AI‑generated image
                alt="Fintech Hero – Retailer serving customer"
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  borderRadius: "20px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                  border: "1px solid rgba(0,0,0,0.05)",
                }}
              />
              {/* Optional floating badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "20px",
                  backgroundColor: "#ffffff",
                  padding: "8px 16px",
                  borderRadius: "40px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontWeight: "500",
                  color: "#1e293b",
                }}
              >
                <span style={{ color: "#f39c12", fontSize: "1.2rem" }}>✓</span>
                100% Secure
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
